import { mock } from './_util';

mock.onGet('/Catalog/GetChannels').reply(200, {
  data: [
    {
      Id: 1,
      MainLanguageDescription: 'Home',
      YourLanguageDescription: 'Ev',
      IsActive: true
    },
    {
      Id: 2,
      MainLanguageDescription: 'Call Center',
      YourLanguageDescription: 'Çağrı Merkezi',
      IsActive: true
    }
  ]
});

mock.onGet('/Catalog/GetConsumerTypes').reply(200, {
  data: [
    {
      Id: 4,
      MainLanguageDescription: 'ServiceShop',
      YourLanguageDescription: 'Servis',
      IsActive: true
    },
    {
      Id: 5,
      MainLanguageDescription: 'Technician',
      YourLanguageDescription: 'Teknisyen',
      IsActive: true
    },
    {
      Id: 6,
      MainLanguageDescription: 'Customer',
      YourLanguageDescription: 'Müsteri',
      IsActive: true
    }
  ]
});

mock.onGet('/Catalog/GetConsumerAddressTypes').reply(200, {
  data: [
    {
      Id: 1,
      MainLanguageDescription: 'Home',
      YourLanguageDescription: 'Ev',
      IsActive: true
    },
    {
      Id: 2,
      MainLanguageDescription: 'Summery',
      YourLanguageDescription: 'Yazlık',
      IsActive: true
    },
    {
      Id: 3,
      MainLanguageDescription: 'Workplace',
      YourLanguageDescription: 'Is Yeri',
      IsActive: true
    }
  ]
});

mock.onGet('/Catalog/GetConsumerPhoneTypes').reply(200, {
  data: [
    {
      Id: 1,
      MainLanguageDescription: 'Home',
      YourLanguageDescription: 'Ev',
      IsActive: true
    },
    {
      Id: 2,
      MainLanguageDescription: 'Work',
      YourLanguageDescription: 'iş',
      IsActive: true
    },
    {
      Id: 3,
      MainLanguageDescription: 'Mobile',
      YourLanguageDescription: 'Mobil',
      IsActive: true
    },
    {
      Id: 4,
      MainLanguageDescription: 'Fax',
      YourLanguageDescription: 'Fax',
      IsActive: true
    }
  ]
});


mock.onGet('/Catalog/GetCommentTypes').reply(200, {
  data: [
    {
      Id: 1,
      MainLanguageDescription: 'Notes',
      YourLanguageDescription: 'Notlar',
      IsActive: true,
      Tenants: [
        {
          Id: 16,
          Tenant: 'United Kingdom'
        },
        {
          Id: 49,
          Tenant: 'Romania'

        }

      ]
    },
    {
      Id: 2,
      MainLanguageDescription: 'Conclusion Note',
      YourLanguageDescription: 'Sonuc Notu',
      IsActive: true,
      Tenants: [
        {
          Id: 16,
          Tenant: 'United Kingdom'
        }

      ]
    }
  ]
});

mock.onGet('/Catalog/GetStatus').reply(200, {
  data: [
    {
      Id: 1,
      MainLanguageDescription: 'Service Paper Created',
      YourLanguageDescription: 'Fişlendi',
      IsActive: true,
      IsOpen: false,
      Tenants: [
        {
          Id: 16,
          Tenant: 'United Kingdom'
        },
        {
          Id: 49,
          Tenant: 'Romania'

        }

      ]
    },
    {
      Id: 2,
      MainLanguageDescription: 'Assigned',
      YourLanguageDescription: 'Atama Yapildi',
      IsActive: true,
      IsOpen: true,
      Tenants: [
        {
          Id: 16,
          Tenant: 'United Kingdom'
        },
        {
          Id: 49,
          Tenant: 'Romania'
        },
        {
          Id: 63,
          Tenant: 'Turkish'
        }

      ]
    }
  ]
});

mock.onGet('/Catalog/GetIssues').reply(200, {
  data: [
    {
      Id: 0,
      MainLanguageDescription: '',
      YourLanguageDescription: '',
      IsActive: true,
      Tenants:[
        {
          Id:0,
          Tenant:''
        }
      ]
    },
  ]
});

mock.onGet('/Catalog/GetPaymentTypes').reply(200, {
  data: [
    {
      Id: 1,
      MainLanguageDescription: 'Cash',
      YourLanguageDescription: 'Nakit'
    },
    {
      Id: 5,
      MainLanguageDescription: 'Card',
      YourLanguageDescription: 'Kredi Kartı'
    }
  ]
});

mock.onGet('/Catalog/GetChannelDetails').reply(200, {
  data: [
    { LanguageId: 1, FieldText: 'Ev', Description: 'Türkçe' },
    { LanguageId: 2, FieldText: 'Home', Description: 'English' },
    { LanguageId: 21, FieldText: 'Casa', Description: 'Spanish' },
    { LanguageId: 22, FieldText: 'Domicile', Description: 'French' },
    { LanguageId: 24, FieldText: 'Zuhause', Description: 'German' },
    { LanguageId: 25, FieldText: 'Дом', Description: 'Russian' },
    { LanguageId: 26, FieldText: 'Acasă', Description: 'Romanian' },
    { LanguageId: 27, FieldText: 'منزل، بيت', Description: 'Arabic' },
    { LanguageId: 28, FieldText: '', Description: 'Czech' },
    { LanguageId: 29, FieldText: '', Description: 'Polish' },
    { LanguageId: 30, FieldText: '', Description: 'Bulgarian' },
    { LanguageId: 31, FieldText: '', Description: 'Chinese' },
    { LanguageId: 32, FieldText: '', Description: 'Slovenian' },
    { LanguageId: 33, FieldText: '', Description: 'Italian' },
    { LanguageId: 34, FieldText: '', Description: 'iw_IL' },
    { LanguageId: 35, FieldText: '', Description: 'Dutch (Belgium)' },
    { LanguageId: 36, FieldText: '', Description: 'Croatian' },
    { LanguageId: 37, FieldText: '', Description: 'Danish' },
    { LanguageId: 38, FieldText: '', Description: 'Estonian' },
    { LanguageId: 39, FieldText: '', Description: 'Finnish' },
    { LanguageId: 40, FieldText: '', Description: 'Greek' },
    { LanguageId: 41, FieldText: '', Description: 'Hungarian' },
    { LanguageId: 42, FieldText: '', Description: 'Portuguese' },
    { LanguageId: 43, FieldText: '', Description: 'Slovak' },
    { LanguageId: 44, FieldText: '', Description: 'Swedish' },
    { LanguageId: 45, FieldText: '', Description: 'Latvian' },
    { LanguageId: 46, FieldText: '', Description: 'Lithuanian' },
    { LanguageId: 47, FieldText: '', Description: 'Norwegian' },
    { LanguageId: 48, FieldText: '', Description: 'Icelandic' },
    { LanguageId: 49, FieldText: '', Description: 'hebrew' },
    { LanguageId: 50, FieldText: '', Description: 'Indonesia' },
    { LanguageId: 51, FieldText: '', Description: 'malaysian' },
    { LanguageId: 52, FieldText: '', Description: 'Ukraynaca' },
    { LanguageId: 53, FieldText: '', Description: 'Vietnamca' }
  ]
});

mock.onGet('/Catalog/GetChannelDetails/1').reply(200, {
  data: [
    { LanguageId: 1, FieldText: 'Çağrı Merkezi', Description: 'Türkçe' },
    { LanguageId: 2, FieldText: 'Call Center', Description: 'English' },
    { LanguageId: 21, FieldText: '', Description: 'Spanish' },
    { LanguageId: 22, FieldText: '', Description: 'French' },
    { LanguageId: 24, FieldText: '', Description: 'German' },
    { LanguageId: 25, FieldText: '', Description: 'Russian' },
    { LanguageId: 26, FieldText: '', Description: 'Romanian' },
    { LanguageId: 27, FieldText: '', Description: 'Arabic' },
    { LanguageId: 28, FieldText: '', Description: 'Czech' },
    { LanguageId: 29, FieldText: '', Description: 'Polish' },
    { LanguageId: 30, FieldText: '', Description: 'Bulgarian' },
    { LanguageId: 31, FieldText: '', Description: 'Chinese' },
    { LanguageId: 32, FieldText: '', Description: 'Slovenian' },
    { LanguageId: 33, FieldText: '', Description: 'Italian' },
    { LanguageId: 34, FieldText: '', Description: 'iw_IL' },
    { LanguageId: 35, FieldText: '', Description: 'Dutch (Belgium)' },
    { LanguageId: 36, FieldText: '', Description: 'Croatian' },
    { LanguageId: 37, FieldText: '', Description: 'Danish' },
    { LanguageId: 38, FieldText: '', Description: 'Estonian' },
    { LanguageId: 39, FieldText: '', Description: 'Finnish' },
    { LanguageId: 40, FieldText: '', Description: 'Greek' },
    { LanguageId: 41, FieldText: '', Description: 'Hungarian' },
    { LanguageId: 42, FieldText: '', Description: 'Portuguese' },
    { LanguageId: 43, FieldText: '', Description: 'Slovak' },
    { LanguageId: 44, FieldText: '', Description: 'Swedish' },
    { LanguageId: 45, FieldText: '', Description: 'Latvian' },
    { LanguageId: 46, FieldText: '', Description: 'Lithuanian' },
    { LanguageId: 47, FieldText: '', Description: 'Norwegian' },
    { LanguageId: 48, FieldText: '', Description: 'Icelandic' },
    { LanguageId: 49, FieldText: '', Description: 'hebrew' },
    { LanguageId: 50, FieldText: '', Description: 'Indonesia' },
    { LanguageId: 51, FieldText: '', Description: 'malaysian' },
    { LanguageId: 52, FieldText: '', Description: 'Ukraynaca' },
    { LanguageId: 53, FieldText: '', Description: 'Vietnamca' }
  ]
});

mock.onGet('/Catalog/GetConsumerTypeDetails').reply(200, {
  data: [
    { LanguageId: 1, FieldText: 'Servis', Description: 'Türkçe' },
    { LanguageId: 2, FieldText: 'ServiceShop', Description: 'English' },
    { LanguageId: 21, FieldText: '', Description: 'Spanish' },
    { LanguageId: 22, FieldText: '', Description: 'French' },
    { LanguageId: 24, FieldText: '', Description: 'German' },
    { LanguageId: 25, FieldText: '', Description: 'Russian' },
    { LanguageId: 26, FieldText: '', Description: 'Romanian' },
    { LanguageId: 27, FieldText: '', Description: 'Arabic' },
    { LanguageId: 28, FieldText: '', Description: 'Czech' },
    { LanguageId: 29, FieldText: '', Description: 'Polish' },
    { LanguageId: 30, FieldText: '', Description: 'Bulgarian' },
    { LanguageId: 31, FieldText: '', Description: 'Chinese' },
    { LanguageId: 32, FieldText: '', Description: 'Slovenian' },
    { LanguageId: 33, FieldText: '', Description: 'Italian' },
    { LanguageId: 34, FieldText: '', Description: 'iw_IL' },
    { LanguageId: 35, FieldText: '', Description: 'Dutch (Belgium)' },
    { LanguageId: 36, FieldText: '', Description: 'Croatian' },
    { LanguageId: 37, FieldText: '', Description: 'Danish' },
    { LanguageId: 38, FieldText: '', Description: 'Estonian' },
    { LanguageId: 39, FieldText: '', Description: 'Finnish' },
    { LanguageId: 40, FieldText: '', Description: 'Greek' },
    { LanguageId: 41, FieldText: '', Description: 'Hungarian' },
    { LanguageId: 42, FieldText: '', Description: 'Portuguese' },
    { LanguageId: 43, FieldText: '', Description: 'Slovak' },
    { LanguageId: 44, FieldText: '', Description: 'Swedish' },
    { LanguageId: 45, FieldText: '', Description: 'Latvian' },
    { LanguageId: 46, FieldText: '', Description: 'Lithuanian' },
    { LanguageId: 47, FieldText: '', Description: 'Norwegian' },
    { LanguageId: 48, FieldText: '', Description: 'Icelandic' },
    { LanguageId: 49, FieldText: '', Description: 'hebrew' },
    { LanguageId: 50, FieldText: '', Description: 'Indonesia' },
    { LanguageId: 51, FieldText: '', Description: 'malaysian' },
    { LanguageId: 52, FieldText: '', Description: 'Ukraynaca' },
    { LanguageId: 53, FieldText: '', Description: 'Vietnamca' }
  ]
});

mock.onGet('/Catalog/GetConsumerAdressTypeDetails').reply(200, {
  data: [
    { LanguageId: 1, FieldText: 'Ev', Description: 'Türkçe' },
    { LanguageId: 2, FieldText: 'Home', Description: 'English' },
    { LanguageId: 21, FieldText: '', Description: 'Spanish' },
    { LanguageId: 22, FieldText: '', Description: 'French' },
    { LanguageId: 24, FieldText: '', Description: 'German' },
    { LanguageId: 25, FieldText: '', Description: 'Russian' },
    { LanguageId: 26, FieldText: 'Acasa', Description: 'Romanian' },
    { LanguageId: 27, FieldText: '', Description: 'Arabic' },
    { LanguageId: 28, FieldText: '', Description: 'Czech' },
    { LanguageId: 29, FieldText: '', Description: 'Polish' },
    { LanguageId: 30, FieldText: '', Description: 'Bulgarian' },
    { LanguageId: 31, FieldText: '', Description: 'Chinese' },
    { LanguageId: 32, FieldText: '', Description: 'Slovenian' },
    { LanguageId: 33, FieldText: '', Description: 'Italian' },
    { LanguageId: 34, FieldText: '', Description: 'iw_IL' },
    { LanguageId: 35, FieldText: '', Description: 'Dutch (Belgium)' },
    { LanguageId: 36, FieldText: '', Description: 'Croatian' },
    { LanguageId: 37, FieldText: '', Description: 'Danish' },
    { LanguageId: 38, FieldText: '', Description: 'Estonian' },
    { LanguageId: 39, FieldText: '', Description: 'Finnish' },
    { LanguageId: 40, FieldText: '', Description: 'Greek' },
    { LanguageId: 41, FieldText: '', Description: 'Hungarian' },
    { LanguageId: 42, FieldText: '', Description: 'Portuguese' },
    { LanguageId: 43, FieldText: '', Description: 'Slovak' },
    { LanguageId: 44, FieldText: '', Description: 'Swedish' },
    { LanguageId: 45, FieldText: '', Description: 'Latvian' },
    { LanguageId: 46, FieldText: '', Description: 'Lithuanian' },
    { LanguageId: 47, FieldText: '', Description: 'Norwegian' },
    { LanguageId: 48, FieldText: '', Description: 'Icelandic' },
    { LanguageId: 49, FieldText: '', Description: 'hebrew' },
    { LanguageId: 50, FieldText: '', Description: 'Indonesia' },
    { LanguageId: 51, FieldText: '', Description: 'malaysian' },
    { LanguageId: 52, FieldText: '', Description: 'Ukraynaca' },
    { LanguageId: 53, FieldText: '', Description: 'Vietnamca' }
  ]
});

mock.onGet('/Catalog/GetConsumerPhoneTypeDetails').reply(200, {
  data: [
    { LanguageId: 1, FieldText: 'Ev', Description: 'Türkçe' },
    { LanguageId: 2, FieldText: 'Home', Description: 'English' },
    { LanguageId: 21, FieldText: '', Description: 'Spanish' },
    { LanguageId: 22, FieldText: '', Description: 'French' },
    { LanguageId: 24, FieldText: '', Description: 'German' },
    { LanguageId: 25, FieldText: '', Description: 'Russian' },
    { LanguageId: 26, FieldText: 'Acasa', Description: 'Romanian' },
    { LanguageId: 27, FieldText: '', Description: 'Arabic' },
    { LanguageId: 28, FieldText: '', Description: 'Czech' },
    { LanguageId: 29, FieldText: '', Description: 'Polish' },
    { LanguageId: 30, FieldText: '', Description: 'Bulgarian' },
    { LanguageId: 31, FieldText: '', Description: 'Chinese' },
    { LanguageId: 32, FieldText: '', Description: 'Slovenian' },
    { LanguageId: 33, FieldText: '', Description: 'Italian' },
    { LanguageId: 34, FieldText: '', Description: 'iw_IL' },
    { LanguageId: 35, FieldText: '', Description: 'Dutch (Belgium)' },
    { LanguageId: 36, FieldText: '', Description: 'Croatian' },
    { LanguageId: 37, FieldText: '', Description: 'Danish' },
    { LanguageId: 38, FieldText: '', Description: 'Estonian' },
    { LanguageId: 39, FieldText: '', Description: 'Finnish' },
    { LanguageId: 40, FieldText: '', Description: 'Greek' },
    { LanguageId: 41, FieldText: '', Description: 'Hungarian' },
    { LanguageId: 42, FieldText: '', Description: 'Portuguese' },
    { LanguageId: 43, FieldText: '', Description: 'Slovak' },
    { LanguageId: 44, FieldText: '', Description: 'Swedish' },
    { LanguageId: 45, FieldText: '', Description: 'Latvian' },
    { LanguageId: 46, FieldText: '', Description: 'Lithuanian' },
    { LanguageId: 47, FieldText: '', Description: 'Norwegian' },
    { LanguageId: 48, FieldText: '', Description: 'Icelandic' },
    { LanguageId: 49, FieldText: '', Description: 'hebrew' },
    { LanguageId: 50, FieldText: '', Description: 'Indonesia' },
    { LanguageId: 51, FieldText: '', Description: 'malaysian' },
    { LanguageId: 52, FieldText: '', Description: 'Ukraynaca' },
    { LanguageId: 53, FieldText: '', Description: 'Vietnamca' }
  ]
});

mock.onGet('/Catalog/GetIssueDetails').reply(200, {
  data: [
    { LanguageId: 1, FieldText: '', Description: 'Türkçe' },
    { LanguageId: 2, FieldText: '', Description: 'English' },
    { LanguageId: 21, FieldText: '', Description: 'Spanish' },
    { LanguageId: 22, FieldText: '', Description: 'French' },
    { LanguageId: 24, FieldText: '', Description: 'German' },
    { LanguageId: 25, FieldText: '', Description: 'Russian' },
    { LanguageId: 26, FieldText: '', Description: 'Romanian' },
    { LanguageId: 27, FieldText: '', Description: 'Arabic' },
    { LanguageId: 28, FieldText: '', Description: 'Czech' },
    { LanguageId: 29, FieldText: '', Description: 'Polish' },
    { LanguageId: 30, FieldText: '', Description: 'Bulgarian' },
    { LanguageId: 31, FieldText: '', Description: 'Chinese' },
    { LanguageId: 32, FieldText: '', Description: 'Slovenian' },
    { LanguageId: 33, FieldText: '', Description: 'Italian' },
    { LanguageId: 34, FieldText: '', Description: 'iw_IL' },
    { LanguageId: 35, FieldText: '', Description: 'Dutch (Belgium)' },
    { LanguageId: 36, FieldText: '', Description: 'Croatian' },
    { LanguageId: 37, FieldText: '', Description: 'Danish' },
    { LanguageId: 38, FieldText: '', Description: 'Estonian' },
    { LanguageId: 39, FieldText: '', Description: 'Finnish' },
    { LanguageId: 40, FieldText: '', Description: 'Greek' },
    { LanguageId: 41, FieldText: '', Description: 'Hungarian' },
    { LanguageId: 42, FieldText: '', Description: 'Portuguese' },
    { LanguageId: 43, FieldText: '', Description: 'Slovak' },
    { LanguageId: 44, FieldText: '', Description: 'Swedish' },
    { LanguageId: 45, FieldText: '', Description: 'Latvian' },
    { LanguageId: 46, FieldText: '', Description: 'Lithuanian' },
    { LanguageId: 47, FieldText: '', Description: 'Norwegian' },
    { LanguageId: 48, FieldText: '', Description: 'Icelandic' },
    { LanguageId: 49, FieldText: '', Description: 'hebrew' },
    { LanguageId: 50, FieldText: '', Description: 'Indonesia' },
    { LanguageId: 51, FieldText: '', Description: 'malaysian' },
    { LanguageId: 52, FieldText: '', Description: 'Ukraynaca' },
    { LanguageId: 53, FieldText: '', Description: 'Vietnamca' }
  ]
});

mock.onGet('/Catalog/GetPaymentTypeDetails').reply(200, {
  data: [
    { LanguageId: 1, FieldText: 'Nakit', Description: 'Türkçe' },
    { LanguageId: 2, FieldText: 'Cash', Description: 'English' },
    { LanguageId: 21, FieldText: '', Description: 'Spanish' },
    { LanguageId: 22, FieldText: '', Description: 'French' },
    { LanguageId: 24, FieldText: '', Description: 'German' },
    { LanguageId: 25, FieldText: '', Description: 'Russian' },
    { LanguageId: 26, FieldText: '', Description: 'Romanian' },
    { LanguageId: 27, FieldText: '', Description: 'Arabic' },
    { LanguageId: 28, FieldText: '', Description: 'Czech' },
    { LanguageId: 29, FieldText: '', Description: 'Polish' },
    { LanguageId: 30, FieldText: '', Description: 'Bulgarian' },
    { LanguageId: 31, FieldText: '', Description: 'Chinese' },
    { LanguageId: 32, FieldText: '', Description: 'Slovenian' },
    { LanguageId: 33, FieldText: '', Description: 'Italian' },
    { LanguageId: 34, FieldText: '', Description: 'iw_IL' },
    { LanguageId: 35, FieldText: '', Description: 'Dutch (Belgium)' },
    { LanguageId: 36, FieldText: '', Description: 'Croatian' },
    { LanguageId: 37, FieldText: '', Description: 'Danish' },
    { LanguageId: 38, FieldText: '', Description: 'Estonian' },
    { LanguageId: 39, FieldText: '', Description: 'Finnish' },
    { LanguageId: 40, FieldText: '', Description: 'Greek' },
    { LanguageId: 41, FieldText: '', Description: 'Hungarian' },
    { LanguageId: 42, FieldText: '', Description: 'Portuguese' },
    { LanguageId: 43, FieldText: '', Description: 'Slovak' },
    { LanguageId: 44, FieldText: '', Description: 'Swedish' },
    { LanguageId: 45, FieldText: '', Description: 'Latvian' },
    { LanguageId: 46, FieldText: '', Description: 'Lithuanian' },
    { LanguageId: 47, FieldText: '', Description: 'Norwegian' },
    { LanguageId: 48, FieldText: '', Description: 'Icelandic' },
    { LanguageId: 49, FieldText: '', Description: 'hebrew' },
    { LanguageId: 50, FieldText: '', Description: 'Indonesia' },
    { LanguageId: 51, FieldText: '', Description: 'malaysian' },
    { LanguageId: 52, FieldText: '', Description: 'Ukraynaca' },
    { LanguageId: 53, FieldText: '', Description: 'Vietnamca' }
  ]
});


mock.onGet('/Catalog/GetCommentTypeDetails').reply(200, {
  data: [
    { LanguageId: 1, FieldText: 'Notlar', Description: 'Türkçe' },
    { LanguageId: 2, FieldText: 'Notes', Description: 'English' },
    { LanguageId: 21, FieldText: '', Description: 'Spanish' },
    { LanguageId: 22, FieldText: '', Description: 'French' },
    { LanguageId: 24, FieldText: 'Anmerkungen', Description: 'German' },
    { LanguageId: 25, FieldText: 'Заметки', Description: 'Russian' },
    { LanguageId: 26, FieldText: 'Note', Description: 'Romanian' },
    { LanguageId: 27, FieldText: 'ملاحظات', Description: 'Arabic' },
    { LanguageId: 28, FieldText: '', Description: 'Czech' },
    { LanguageId: 29, FieldText: '', Description: 'Polish' },
    { LanguageId: 30, FieldText: '', Description: 'Bulgarian' },
    { LanguageId: 31, FieldText: '', Description: 'Chinese' },
    { LanguageId: 32, FieldText: '', Description: 'Slovenian' },
    { LanguageId: 33, FieldText: '', Description: 'Italian' },
    { LanguageId: 34, FieldText: '', Description: 'iw_IL' },
    { LanguageId: 35, FieldText: '', Description: 'Dutch (Belgium)' },
    { LanguageId: 36, FieldText: '', Description: 'Croatian' },
    { LanguageId: 37, FieldText: '', Description: 'Danish' },
    { LanguageId: 38, FieldText: '', Description: 'Estonian' },
    { LanguageId: 39, FieldText: '', Description: 'Finnish' },
    { LanguageId: 40, FieldText: '', Description: 'Greek' },
    { LanguageId: 41, FieldText: '', Description: 'Hungarian' },
    { LanguageId: 42, FieldText: '', Description: 'Portuguese' },
    { LanguageId: 43, FieldText: '', Description: 'Slovak' },
    { LanguageId: 44, FieldText: '', Description: 'Swedish' },
    { LanguageId: 45, FieldText: '', Description: 'Latvian' },
    { LanguageId: 46, FieldText: '', Description: 'Lithuanian' },
    { LanguageId: 47, FieldText: '', Description: 'Norwegian' },
    { LanguageId: 48, FieldText: '', Description: 'Icelandic' },
    { LanguageId: 49, FieldText: '', Description: 'hebrew' },
    { LanguageId: 50, FieldText: '', Description: 'Indonesia' },
    { LanguageId: 51, FieldText: '', Description: 'malaysian' },
    { LanguageId: 52, FieldText: '', Description: 'Ukraynaca' },
    { LanguageId: 53, FieldText: '', Description: 'Vietnamca' }
  ]
});


mock.onGet('/Catalog/GetStatusDetails').reply(200, {
  data: [
    { LanguageId: 1, FieldText: 'Fişlendi', Description: 'Türkçe' },
    { LanguageId: 2, FieldText: 'Service Paper Created', Description: 'English' },
    { LanguageId: 21, FieldText: '', Description: 'Spanish' },
    { LanguageId: 22, FieldText: '', Description: 'French' },
    { LanguageId: 24, FieldText: '', Description: 'German' },
    { LanguageId: 25, FieldText: '', Description: 'Russian' },
    { LanguageId: 26, FieldText: '', Description: 'Romanian' },
    { LanguageId: 27, FieldText: '', Description: 'Arabic' },
    { LanguageId: 28, FieldText: '', Description: 'Czech' },
    { LanguageId: 29, FieldText: '', Description: 'Polish' },
    { LanguageId: 30, FieldText: '', Description: 'Bulgarian' },
    { LanguageId: 31, FieldText: '', Description: 'Chinese' },
    { LanguageId: 32, FieldText: '', Description: 'Slovenian' },
    { LanguageId: 33, FieldText: '', Description: 'Italian' },
    { LanguageId: 34, FieldText: '', Description: 'iw_IL' },
    { LanguageId: 35, FieldText: '', Description: 'Dutch (Belgium)' },
    { LanguageId: 36, FieldText: '', Description: 'Croatian' },
    { LanguageId: 37, FieldText: '', Description: 'Danish' },
    { LanguageId: 38, FieldText: '', Description: 'Estonian' },
    { LanguageId: 39, FieldText: '', Description: 'Finnish' },
    { LanguageId: 40, FieldText: '', Description: 'Greek' },
    { LanguageId: 41, FieldText: '', Description: 'Hungarian' },
    { LanguageId: 42, FieldText: '', Description: 'Portuguese' },
    { LanguageId: 43, FieldText: '', Description: 'Slovak' },
    { LanguageId: 44, FieldText: '', Description: 'Swedish' },
    { LanguageId: 45, FieldText: '', Description: 'Latvian' },
    { LanguageId: 46, FieldText: '', Description: 'Lithuanian' },
    { LanguageId: 47, FieldText: '', Description: 'Norwegian' },
    { LanguageId: 48, FieldText: '', Description: 'Icelandic' },
    { LanguageId: 49, FieldText: '', Description: 'hebrew' },
    { LanguageId: 50, FieldText: '', Description: 'Indonesia' },
    { LanguageId: 51, FieldText: '', Description: 'malaysian' },
    { LanguageId: 52, FieldText: '', Description: 'Ukraynaca' },
    { LanguageId: 53, FieldText: '', Description: 'Vietnamca' }
  ]
});


mock.onGet('/Catalog/TenantList').reply(200, {
  data: [
    {
      Id: 1,
      Description: 'Turkey',
      checked: false

    },
    {
      Id: 2,
      Description: 'United Kingdom',
      checked: false

    },
    {
      Id: 3,
      Description: 'Romania',
      checked: true

    }
  ]
});
